import React, { useEffect } from "react";
// No longer need useNavigate if using window.location.replace
import { Box, CircularProgress, Typography } from "@mui/material";

const LogoutComponent = () => {
  // const navigate = useNavigate(); // You can remove this line

  useEffect(() => {
    // 1. Clear authentication token from localStorage and any other user data
    localStorage.removeItem("token");
    localStorage.removeItem("user"); // Also remove other user-related data if stored

    // 2. Force a full page reload and navigate to the sign-in page
    // This ensures a clean state for the entire application and resolves any lingering issues.
    window.location.replace("/authentication/sign-in");
  }, []); // The dependency array is now empty because "navigate" is no longer a dependency

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        textAlign: "center",
      }}
    >
      <CircularProgress color="primary" sx={{ mb: 2 }} />
      <Typography variant="h5">Cerrando sesión...</Typography>
    </Box>
  );
};

export default LogoutComponent;
